import styled, { css } from 'styled-components';

interface Props {
  isFirstColumn: boolean;
  isFirstRow: boolean;
  isRowDivider: boolean;
  isColumnDivider: boolean;
  isCorrect: boolean;
  itsCorrected: boolean;
  isHint: boolean;
  width: number;
  height: number;
}

export const Container = styled.div<Props>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${(props) => 75 / props.height}vh;
  height: ${(props) => 75 / props.height}vh;
  border: 0;
  margin: 0.08rem;

  @media (min-width: 996px) and (min-height: 975px) {
    width: ${(props) => 60 / props.height}vh;
    height: ${(props) => 60 / props.height}vh;
  }

  @media (min-width: 996px) and (min-height: 1050px) {
    width: ${(props) => 55 / props.height}vh;
    height: ${(props) => 55 / props.height}vh;
  }

  @media (min-width: 996px) and (min-height: 1200px) {
    width: ${(props) => 50 / props.height}vh;
    height: ${(props) => 50 / props.height}vh;
  }

  @media (min-width: 996px) and (min-height: 1300px) {
    width: ${(props) => 45 / props.height}vh;
    height: ${(props) => 45 / props.height}vh;
  }

  @media (max-width: 996px) and (min-height: 1000px) {
    width: ${(props) => 55 / props.height}vh;
    height: ${(props) => 55 / props.height}vh;
  }

  @media (max-width: 996px) and (min-height: 1100px) {
    width: ${(props) => 60 / props.height}vh;
    height: ${(props) => 60 / props.height}vh;
  }

  @media (max-width: 996px) and (min-height: 1200px) {
    width: ${(props) => 50 / props.height}vh;
    height: ${(props) => 50 / props.height}vh;
  }

  @media (max-width: 996px) and (max-height: 700px) {
    width: ${(props) => 70 / props.height}vh;
    height: ${(props) => 70 / props.height}vh;
  }

  @media (max-width: 996px) and (max-height: 600px) {
    width: ${(props) => 60 / props.height}vh;
    height: ${(props) => 60 / props.height}vh;
  }

  @media (max-width: 996px) and (max-height: 450px) {
    width: ${(props) => 40 / props.height}vh;
    height: ${(props) => 40 / props.height}vh;
  }

  @media (max-width: 996px) {
    width: ${(props) => 85 / props.width}vw;
    height: ${(props) => 85 / props.width}vw;
  }

  @media (max-width: 996px) and (max-height: 920px) {
    width: ${(props) => 72 / props.width}vh;
    height: ${(props) => 72 / props.width}vh;
  }

  @media (max-width: 550px) {
    width: ${(props) => 85 / props.width}vw;
    height: ${(props) => 85 / props.width}vw;
  }

  @media (max-height: 475px) {
    width: ${(props) => 60 / props.width}vh;
    height: ${(props) => 60 / props.width}vh;
  }

  @media (max-height: 436px) {
    width: ${(props) => 55 / props.width}vh;
    height: ${(props) => 55 / props.width}vh;
  }

  @media (max-height: 400px) {
    width: ${(props) => 50 / props.width}vh;
    height: ${(props) => 50 / props.width}vh;
  }

  transition: all linear 0.2s;
  ${(props) =>
    props.isFirstColumn &&
    css`
      margin-left: 0.3rem;
    `}
  ${(props) =>
    props.isFirstRow &&
    css`
      margin-top: 0.3rem;
    `}
    background-color: ${({ theme }) => theme.background};
  ${(props) =>
    props.isRowDivider &&
    css`
      margin-bottom: 0.3rem;
    `}
  ${(props) =>
    props.isColumnDivider &&
    css`
      margin-right: 0.3rem;
    `}
    ${(props) =>
    props.isHint &&
    css`
      font-weight: bold;
      font-size: 1.4rem;
    `};
  ${(props) =>
    props.itsCorrected &&
    !props.isHint &&
    (props.isCorrect
      ? css`
          background-color: ${({ theme }) => theme.green};
        `
      : css`
          background-color: ${({ theme }) => theme.red};
        `)}
  input {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: none;
    text-align: center;
    background-color: transparent;
    ${(props) =>
      props.itsCorrected &&
      (props.isCorrect
        ? css`
            color: ${({ theme }) => theme.text};
            font-weight: bold;
          `
        : css`
            color: ${({ theme }) => theme.text};
            font-weight: bold;
          `)}
    font-size: 1.6rem;
    ${(props) =>
      props.isHint &&
      css`
        font-weight: bold;
      `};
    margin: 0;
    padding: 0;
    ${(props) =>
      !props.itsCorrected &&
      css`
        cursor: pointer;
      `}
  }
  input:disabled {
    cursor: default;
    &:hover {
      ${(props) =>
        !props.itsCorrected &&
        !props.isHint &&
        css`
          background-color: white;
        `}
    }
  }
  input:hover {
    ${(props) =>
      !props.itsCorrected &&
      !props.isHint &&
      css`
        background-color: ${({ theme }) => theme.nimbus};
      `}
  }
  input:focus {
    ${(props) =>
      !props.itsCorrected &&
      css`
        background-color: ${({ theme }) => theme.smoothBlue};
      `}
  }
`;
